import fetch from '@/utils/fetch'
// 获取用户所在群列表
export function getGroups (params) {
  return fetch({
    url: '/groups',
    method: 'get',
    params: {
      search_name: params.search_name,
      category: params.category,
      tags: params.tags,
      group_review: params.group_review,
      offset: params.offset,
      limit: params.limit
    }
  })
}

// 获取公开群列表
export function publicGroups (params) {
  return fetch({
    url: '/publicGroups',
    method: 'get',
    params: {
      search_name: params.search_name,
      category: params.category,
      tags: params.tags,
      type: params.type,
      user_number: params.user_number,
      offset: params.offset,
      limit: params.limit
    }
  })
}

// 获取用户所在群的详情
export function getGroupInfo (group_number) {
  return fetch({
    url: '/groupinfo/' + group_number,
    method: 'get'
  })
}

// 获取公开群的详情
export function getGroupPublicInfo (group_number) {
  return fetch({
    url: '/groupinfo/public/' + group_number,
    method: 'get'
  })
}

// 获取群成员
export function getGroupMembers (params) {
  return fetch({
    url: '/groupMembers/' + params.group_number,
    method: 'get',
    params: {
      search_name: params.search_name
    }
  })
}
// 解散群
export function groupCancel (data) {
  return fetch({
    url: '/groupCancel',
    method: 'post',
    data
  })
}
//  添加/移除群成员与退出群
export function groupMember (data) {
  return fetch({
    url: '/groupMember',
    method: 'post',
    data
  })
}
// 获取公开群标签
export function groupAllGroupTags (params) {
  return fetch({
    url: '/groupAllGroupTags',
    method: 'get',
    params:{
      params: params.group_number
    }
  })
}

// 检查群名称是否已经被使用（群名称不允许重复）
export function checkGroupName (params) {
  return fetch({
    url: '/group/search/' + params.group_number,
    method: 'get',
    params: {
      search_name: params.search_name
    }
  })
}

// 创建/修改群
export function group (data) {
  return fetch({
    url: '/group',
    method: 'post',
    data
  })
}
// 获取群类型列表
export function getGroupCategorys () {
  return fetch({
    url: '/group/categorys',
    method: 'get'
  })
}

// 【申请入群】第一步：入群申请
export function groupApply (data) {
  return fetch({
    url: '/groupApply',
    method: 'post',
    data
  })
}
// 获取入群申请列表
export function groupRequests (params = {}) {
  return fetch({
    url: '/group/requests',
    method: 'get',
    params:{
      group_number: params.group_number,
      type: params.type,
      user_number: params.user_number
    }
  })
}
// 审核入群申请
export function handleRequest (data) {
  return fetch({
    url: '/group/requests',
    method: 'post',
    data
  })
}
// 【群成员】【身份管理】
export function groupMemberIdentity (data) {
  return fetch({
    url: '/groupMemberIdentity',
    method: 'post',
    data
  })
}
// 设置群标签
export function groupTags (data) {
  return fetch({
    url: '/group/tags',
    method: 'post',
    data
  })
}
// 【群资源】【保存至我的网盘】
export function saveGroupResource (data) {
  return fetch({
    url: '/group/resource/savetocloud',
    method: 'post',
    data
  })
}
// 获取群主页内容
export function getGroupContent (group_number) {
  return fetch({
    url: '/group/home/content',
    method: 'get',
    params: {
      group_number: group_number
    }
  })
}
// 【群】【主页】、【创建、修改】
export function saveGroupContent (data) {
  return fetch({
    url: '/group/home/content',
    method: 'post',
    data
  })
}

// 获取群使用协议内容
export function groupProtocol () {
  return fetch({
    url: '/group/protocol',
    method: 'get'
  })
}

/**
 * 群角色相关
 */

// 【群】【群角色】【群角色列表】
export function getGroupRoleList (data) {
  return fetch({
    url: '/group_role/list',
    method: 'post',
    data
  })
}

// 【群】【群角色】【获取角色可选的权限列表】
export function getGroupRoleOperations (data) {
  return fetch({
    url: '/group_role/group_operations',
    method: 'post',
    data
  })
}

// 【群】【群角色】【获取角色可选择的目录】
export function getGroupRoleFolders (data) {
  return fetch({
    url: '/group_role/group_folders',
    method: 'post',
    data
  })
}

// 【群】【群角色】【新增角色】
export function addGroupRole (data) {
  return fetch({
    url: '/group_role/create',
    method: 'post',
    data
  })
}

// 【群】【群角色】【编辑角色】
export function saveGroupRole (data) {
  return fetch({
    url: '/group_role/edit',
    method: 'post',
    data
  })
}

// 【群】【群角色】【获取编辑角色信息】
export function getGroupRoleInfo (data) {
  return fetch({
    url: '/group_role/info',
    method: 'post',
    data
  })
}

// 【群】【群角色】【删除角色】
export function deleteGroupRole (data) {
  return fetch({
    url: '/group_role/delete',
    method: 'post',
    data
  })
}

// 【群】【群角色】【获取群角色分配的用户】
export function getGroupRoleMembers (data) {
  return fetch({
    url: '/group_role_member/members',
    method: 'post',
    data
  })
}

// 【群】【群角色】【配置群角色用户】
export function setGroupRoleMembers (data) {
  return fetch({
    url: '/group_role_member/edit',
    method: 'post',
    data
  })
}

// 【群】【群角色】【删除群角色用户】
export function deleteGroupRoleMembers (data) {
  return fetch({
    url: '/group_role_member/delete',
    method: 'post',
    data
  })
}

// 【群】【群角色】【获取用户的角色】
export function getGroupRolePermissions (data) {
  return fetch({
    url: '/group_user_role/get_privileges',
    method: 'post',
    data
  })
}

// 【群】【群角色】【获取一级目录已有的权限】
export function getGroupResourceRoleFolderRoleList (data) {
  return fetch({
    url: '/group_resource_role/folder_role_list',
    method: 'post',
    data
  })
}

// 【群】【群角色】【分配群目录权限给群用户】
export function setGroupResourceRoleGrantToMembers (data) {
  return fetch({
    url: '/group_resource_role/grant_to_members',
    method: 'post',
    data
  })
}


// 【群】【群角色】【批量分配群目录权限给群用户】
export function setBatchGroupResourceRoleGrantToMembers (data) {
  return fetch({
    url: '/group_resource_role/batch_grant_to_members',
    method: 'post',
    data
  })
}

// 【群】【群角色】【获取群资源角色类型】
export function getGroupResourceRoleRoleTypes (data) {
  return fetch({
    url: '/group_resource_role/role_types',
    method: 'post',
    data
  })
}

// 【群】【获取云盘/群盘容量信息】
export function getCapacit () {
  return fetch({
    url: '/group_capacit/get',
    method: 'post'
  })
}

// 【群】【群角色】【获取群中成员的权限的列表】
export function getGroupMemberRights (data) {
  return fetch({
    url: '/group_resource_role/get_member_rights',
    method: 'post',
    data
  })
}

// 【群】【群角色】【设置新入群成员一级目录的权限】
export function setGroupNewUserRole (data) {
  return fetch({
    url: '/group_resource_role/set_new_user_role',
    method: 'post',
    data
  })
}